<main
    [innerHTML]="'dynamische_frontend_texte.barrierefreiheit.page_content.leichte_sprache' | translate | safeStyle"
></main>
